import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { ChevronUp, ChevronDown, Pencil, Trash2 } from "lucide-react";

function CatRow({ c, i, total, active, count, onSelect, onMove, onEdit, onDelete }) {
  const { setNodeRef, isOver } = useDroppable({ id: `cat:${c.id}` });
  return (
    <div ref={setNodeRef} className={`flex items-center gap-1 rounded-xl px-2 py-1.5 transition-colors ${isOver ? "ring-2 ring-gold bg-gold/20 text-forest" : active ? "bg-forest text-white" : "hover:bg-cream-muted text-forest"}`}>
      <button onClick={() => onSelect(c.id)} className="flex-1 text-left text-sm py-1 min-w-0" data-testid={`mm-cat-${c.id}`}>
        <span className="opacity-60 mr-1">{i + 1}.</span><span className="font-medium">{c.name_bg || c.name}</span>
        <span className={`ml-2 text-xs ${active ? "text-gold-light" : "text-muted-foreground"}`}>{count}</span>
        {c.vat_rate != null && <span className="ml-1 text-[10px] opacity-60">ДДС {c.vat_rate}%</span>}
      </button>
      <button onClick={() => onMove(i, -1)} disabled={i === 0} className="p-1 opacity-70 hover:opacity-100 disabled:opacity-20" data-testid={`mm-cat-up-${c.id}`}><ChevronUp className="w-4 h-4" /></button>
      <button onClick={() => onMove(i, 1)} disabled={i === total - 1} className="p-1 opacity-70 hover:opacity-100 disabled:opacity-20" data-testid={`mm-cat-down-${c.id}`}><ChevronDown className="w-4 h-4" /></button>
      <button onClick={() => onEdit(c)} className="p-1 opacity-70 hover:opacity-100" data-testid={`mm-cat-edit-${c.id}`}><Pencil className="w-3.5 h-3.5" /></button>
      <button onClick={() => onDelete(c.id)} className="p-1 opacity-70 hover:opacity-100" data-testid={`mm-cat-delete-${c.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
    </div>
  );
}

export const CategoryList = ({ categories, products, activeId, onSelect, onMove, onEdit, onDelete }) => (
  <div className="bg-white rounded-2xl border border-gold/10 shadow-soft p-2 lg:max-h-[75vh] overflow-y-auto" data-testid="mm-category-list">
    <p className="text-[11px] text-muted-foreground px-2 pb-1">Пуснете ястие върху категория, за да го преместите.</p>
    {categories.map((c, i) => (
      <CatRow key={c.id} c={c} i={i} total={categories.length} active={c.id === activeId}
        count={products.filter((p) => p.category_id === c.id).length} onSelect={onSelect} onMove={onMove} onEdit={onEdit} onDelete={onDelete} />
    ))}
  </div>
);
